import {
    styled,
    KpiCard as KpiCardUi,
    KpiError as KpiErrorUi,
    KpiSkeleton as KpiSkeletonUi,
    styledForMobile,
    Typography,
} from "@l2r-front/l2r-ui"


export const KpiSkeleton = styled(KpiSkeletonUi)(() => ({
    width: "100%",
    height: "100%",
}))

export const KpiError = styled(KpiErrorUi)(() => ({
    width: "100%",
    height: "100%",
}))

export const ChartContainer = styled("div")({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    flex: "1 1 auto",
})

export const Title = styledForMobile(Typography)(() => ({
    marginRight: "auto",
    textAlign: "left",
    flex: "0 0 auto",
}))

export const KpiCard = styled(KpiCardUi)(() => ({
    justifyContent: "flex-start",
    "-webkit-user-drag": "none",
}))